import React, { useEffect, useState } from "react";
import login from "./design.module.css";
import { useForm } from "react-hook-form";
import { NavLink, useNavigate } from "react-router-dom";
import { IoEye, IoEyeOff } from "react-icons/io5";
import { CiLock } from "react-icons/ci";
import { resetPassword } from "../../Services/APIrequests";
import { SuccessSwal, warningSwal } from "../../Util/Toast";
import { setAuthToken } from "../../Services/config";
import { useSearchParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
const Resetpassword = () => {
    const [searchParams] = useSearchParams();
    const location = useLocation();
    // const navigate=useNavigate()
    const [showPassword, setShowPassword] = useState(false);
    const [hidePassword, setHidePassword] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const onSubmit = async (data) => {
        if (data.newPassword !== data.confirmPassword) {
            setErrorMessage("Passwords do not match!");
            return;
        }

        const body = {
            newPassword: data.newPassword,
            confirmPassword: data.confirmPassword,
        };

        try {
            const response = await resetPassword(
                body,
                searchParams.get("token")
            );
            if (response?.status === 200) {
                SuccessSwal("Success", response.data.message);
                navigate("/login", { state: { from: location.pathname } });
            } else {
                setErrorMessage(response.data.message);
            }
        } catch (error) {
            warningSwal(
                "Error",
                error.response?.data?.message || "Something went wrong"
            );
        }
    };

    return (
        <div className={login.Comman_Container}>
            <div className={login.bgcontainer}>
                <div className={login.header_section}>
                    <h1 className={login.header_text}>Reset Password</h1>
                </div>
                <div className={login.form_section}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        {/* New Password Input */}
                        <div className={login["form-control"]}>
                            <label htmlFor="newPassword">New Password</label>
                            <div className={login.input_container}>
                                <input
                                    type={hidePassword ? "text" : "password"}
                                    placeholder="Type your new password"
                                    {...register("newPassword", {
                                        required: "Password is required!",
                                    })}
                                />
                                <p className={login.icon}>
                                    <CiLock size={22} stroke={5} />
                                </p>
                                <p className={login.picons}>
                                    {hidePassword ? (
                                        <IoEyeOff
                                            onClick={() =>
                                                setHidePassword(false)
                                            }
                                        />
                                    ) : (
                                        <IoEye
                                            onClick={() =>
                                                setHidePassword(true)
                                            }
                                        />
                                    )}
                                </p>
                            </div>
                            {errors.newPassword && (
                                <p className={login.error}>
                                    {errors.newPassword.message}
                                </p>
                            )}
                        </div>

                        {/* Confirm Password Input */}
                        <div className={login["form-control"]}>
                            <label htmlFor="confirmPassword">
                                Confirm Password
                            </label>
                            <div className={login.input_container}>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Confirm your password"
                                    {...register("confirmPassword", {
                                        required:
                                            "Confirm password is required!",
                                    })}
                                />
                                <p className={login.icon}>
                                    <CiLock size={22} stroke={5} />
                                </p>
                                <p className={login.picons}>
                                    {showPassword ? (
                                        <IoEyeOff
                                            onClick={() =>
                                                setShowPassword(false)
                                            }
                                        />
                                    ) : (
                                        <IoEye
                                            onClick={() =>
                                                setShowPassword(true)
                                            }
                                        />
                                    )}
                                </p>
                            </div>
                            {errors.confirmPassword && (
                                <p className={login.error}>
                                    {errors.confirmPassword.message}
                                </p>
                            )}
                        </div>

                        {/* Display Error Message */}
                        {errorMessage && (
                            <p className={login.error}>{errorMessage}</p>
                        )}

                        {/* Submit Button */}
                        <div className={login.btncontainer}>
                            <input type="submit" value="Submit" />
                        </div>
                    </form>
                </div>
                <div className={login.bottom_textcontainer}>
                    <h2 className={login.conetnt_text}>
                        Already have an account?{" "}
                        <NavLink to="/login">Login</NavLink>
                    </h2>
                </div>
            </div>
        </div>
    );
};

export default Resetpassword;
